import React, { useEffect } from 'react';
import { isIOS, isSafari } from 'react-device-detect';
import { DetailWidgetInteractionItem, StyleProps } from '../WidgetElement';

const generateIframeStyle = (style: StyleProps, isShowWidget: boolean) => {
	const {
		transformSettings: { borderRadiusBottom, borderRadiusLeft, borderRadiusRight, borderRadiusTop },
	} = style;

	return {
		opacity: isShowWidget ? 1 : 0,
		border: 'none',
		borderTopRightRadius: `${borderRadiusTop}px`,
		borderBottomRightRadius: `${borderRadiusRight}px`,
		borderBottomLeftRadius: `${borderRadiusBottom}px`,
		borderTopLeftRadius: `${borderRadiusLeft}px`,
	};
};

const Iframe = ({ id, style, data, widgetRef, position = 0 }: DetailWidgetInteractionItem) => {
	const {
		coordinate: { x, y },
		dimension: { w = 150, h = 100 },
	} = style;

	const centerPoint = {
		x: x + w - w / 2,
		y: y + h - h / 2,
	};

	const {
		start,
		end,
		settings: { url },
	} = data as any;

	let isShowWidget = position >= start && position < end;

	let renderUrl = url || 'https://qbrick.com';
	const isValidUrl = renderUrl.match('^(http|https)://');
	if (isValidUrl?.[0] !== 'http://' && isValidUrl?.[0] !== 'https://') {
		renderUrl = `https://${renderUrl}`;
	}

	useEffect(() => {
		if (!isIOS && !isSafari) {
			return;
		}

		const iframeOverLay = document.getElementById('iframeWidgetsLayer');

		if (!iframeOverLay) {
			return;
		}

		const wrapperId = `wrapper-iframe-${id}`;
		document.getElementById(wrapperId)?.remove();

		const iframePosition = (widgetRef as any)?.current?.getBoundingClientRect() || { x: 0, y: 0, width: 0, height: 0 };
		const { x: iframeX, y: iframeY, width, height } = iframePosition;
		const wrapperDiv = document.createElement('div');
		wrapperDiv.id = wrapperId;
		wrapperDiv.style.position = 'absolute';
		wrapperDiv.style.top = `${iframeY}px`;
		wrapperDiv.style.left = `${iframeX}px`;
		wrapperDiv.style.width = `${width}px`;
		wrapperDiv.style.height = `${height}px`;
		wrapperDiv.style.transformOrigin = `${centerPoint.x}px ${centerPoint.y}px`;
		wrapperDiv.style.pointerEvents = 'auto';
		wrapperDiv.style.opacity = isShowWidget ? '1' : '0';

		const iframeElement = document.createElement('iframe');
		iframeElement.src = renderUrl;
		iframeElement.style.width = `${w}px`;
		iframeElement.style.height = `${h}px`;
		iframeElement.style.transformOrigin = `0 0`;
		iframeElement.style.transform = `scale(${width / w})`;
		iframeElement.style.pointerEvents = 'auto';
		iframeElement.style.border = 'none';

		wrapperDiv.appendChild(iframeElement);
		iframeOverLay.appendChild(wrapperDiv);

		return () => {
			document.getElementById(wrapperId)?.remove();
		};
	}, [renderUrl, widgetRef, w, h, centerPoint.x, centerPoint.y, id, isShowWidget, window.innerWidth]);

	if (isIOS || isSafari) {
		return (
			<g id={id} style={{ pointerEvents: isShowWidget ? 'auto' : 'none' }}>
				<foreignObject ref={widgetRef} x={x} y={y} width={w} height={h}></foreignObject>
			</g>
		);
	}

	return (
		<g id={id} style={{ pointerEvents: isShowWidget ? 'auto' : 'none' }}>
			<foreignObject
				ref={widgetRef}
				x={x}
				y={y}
				width={w}
				height={h}
				style={{ transformOrigin: `${centerPoint.x}px ${centerPoint.y}px`, position: 'relative' }}
			>
				<iframe
					src={renderUrl}
					className="widget iframe-widget"
					style={{
						...generateIframeStyle(style, isShowWidget),
						width: '100%',
						height: '100%',
					}}
				/>
			</foreignObject>
		</g>
	);
};

export default Iframe;
